// Utility to detect browser name, device type and userAgent
export default function getClientInfo() {
  if (typeof window === 'undefined') {
    return { browserName: null, deviceType: null, userAgent: null };
  }

  const ua = navigator.userAgent || '';
  const uaData = navigator.userAgentData;
  let browserName = null;

  // Prefer userAgentData when available
  try {
    if (uaData && Array.isArray(uaData.brands) && uaData.brands.length > 0) {
      // Pick the most specific non-Chromium brand if possible
      const brandEntry = uaData.brands.find(b => b.brand && b.brand.toLowerCase() !== 'chromium') || uaData.brands[0];
      browserName = brandEntry?.brand || null;
    } else {
      if (/Edg\//.test(ua)) browserName = 'Edge';
      else if (/OPR\//.test(ua) || /Opera/.test(ua)) browserName = 'Opera';
      else if (/Chrome\//.test(ua) && !/Edg\//.test(ua) && !/OPR\//.test(ua)) browserName = 'Chrome';
      else if (/Safari\//.test(ua) && !/Chrome\//.test(ua)) browserName = 'Safari';
      else if (/Firefox\//.test(ua)) browserName = 'Firefox';
      else browserName = 'Unknown';
    }
  } catch (e) {
    browserName = null;
  }

  const isMobile = /Mobi|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua);
  const isTablet = /Tablet|iPad/i.test(ua);
  const deviceType = isMobile ? 'Mobile' : isTablet ? 'Tablet' : 'Desktop';

  return { browserName, deviceType, userAgent: ua || null };
}



